import React from 'react';
import Group from '@material-ui/icons/Group';
import Person from '@material-ui/icons/Person';

import ParticipantsTab from './ParticipantsTab.container';
import GroupsTab from './GroupsTab.container';
import TabLabel from './TabLabel';

export default [
  {
    id: 'participants',
    label: <TabLabel icon={<Person />} text="Participants" />,
    content: ParticipantsTab,
    documentTitlePrefix: 'Participants',
    visible: () => true,
  },
  {
    id: 'groups',
    label: <TabLabel icon={<Group />} text="Groups" />,
    content: GroupsTab,
    documentTitlePrefix: 'Groups',
    visible: () => true,
  },
];
